import { Table, TableProps } from "antd";
import Rateio from "../../../../../Models/Financeiro/Titulo/Rateio";
import { Ordenar } from "../../../../../Utils/Ordenacao";
import { ColumnsType } from "antd/es/table";
import ResponsiveAntdTable, { ResponsiveAntdTableProps } from "@/Components/ResponsiveAntdTable";

interface IRateioTableBasicProps extends ResponsiveAntdTableProps<Rateio, {}> {
    ocultarColunas?:number[]
}
export default function RateioTableBasic ({
    dataSource,
    style,
    pagination,
    columns,
    ocultarColunas,
    ...rest
}:IRateioTableBasicProps) {
    ocultarColunas = ocultarColunas ?? [];

    return <ResponsiveAntdTable<Rateio, {}>
        disableResponsiveness
        csv={{
            enabled: true,
            filename: "rateios.csv"
        }}
        style={{
            marginTop : 8,
            ...style
        }}
        dataSource={dataSource ?? []}
        pagination={{
            hideOnSinglePage : true,
            ...pagination
        }}
        rowKey={(e) => e.codigo}
        columns={
            ([
                {
                    title: "Plano de contas",
                    dataIndex: ["planoConta", "descricao"],
                    key: 50
                },
                {
                    title: "Cento de custos",
                    dataIndex: ["centroCusto", "descricao"],
                    key: 60
                },
                {
                    title: "Percentual (%)",
                    dataIndex: ["percentual"],
                    key: 70,
                 
                },
                ...(columns ?? [])
            ] as ColumnsType<Rateio>).filter(f => !ocultarColunas.some(any => any == f.key)).sort((coluna1, coluna2) => Ordenar.Numero(Number(coluna1.key), Number(coluna2.key)))
        }
        {...rest}
    ></ResponsiveAntdTable>;
}